import {APIService} from "../../common/APIService";
import {ProjectType} from "../../dto/ProjectType";

export class ProjectTypeService extends APIService {
  public async browse() {
    const json = await this.getJson<{data: object[]}>(`project-types`)
    return json.data.map(item => ProjectType.fromJson(item))
  }

  public async add(name: string) {
    const json = await this.postJson<{data: object[]}>(`project-types`, {
      name: name,
    })
    return ProjectType.fromJson(json.data)
  }

  public async edit(projectTypeId: string, name: string) {
    const json = await this.putJson<{data: object[]}>(`project-types/${projectTypeId}`, {
      name: name,
    })
    return ProjectType.fromJson(json.data)
  }

  public async delete(projectTypeId: string) {
    await this.deleteJson(`project-types/${projectTypeId}`)
  }
}